import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NormeSpaDualisticoWarningsService } from './warnings/norme-spa-dualistico.warnings';
import { NormeSpaDualisticoFieldValidators } from './validators/norme-spa-dualistico.field-validators';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [NormeSpaDualisticoWarningsService, NormeSpaDualisticoFieldValidators],
})
export class NormeSpaDualisticoFormModule {}
